<template>
  <div>
    <div>
      <h3 class="display-title-3 header-title primary--text"><b>{{$t('plansAndPrices').toLowerCase()}}</b></h3>
    </div>
    <div class="subtitle-deafault mt-5">
      {{$t('payPerYearInfo')}}
    </div>
    <v-card elevation="0" :width="['xs'].includes($vuetify.breakpoint.name) ? '100%' : ['sm'].includes($vuetify.breakpoint.name) ? '80%' : ['md'].includes($vuetify.breakpoint.name) ? '30vw' : '20vw'">
        <v-tabs 
          class="mt-5" 
          hide-slider 
          background-color="#0079F1" 
          v-model="subscribleYear" 
          style="border-radius: 25px"
          grow
          >
          <v-tab v-for="item in [{value: 0, description: $t('montly')}, {value: 1, description: $t('yearly')}]" 
            :key="item.value" 
            :tab-value="item.value" 
            :class="(item.value == subscribleYear ? '': 'color-green-blue') + ` ma-1 text-lowercase`" 
            active-class="tab-item-subscrible-year">
            {{ item.description }}
          </v-tab>
        </v-tabs>
    </v-card>

    <v-card elevation="0" :width="'100%'" v-if="false">
        <v-tabs 
          class="mt-5" 
          hide-slider 
          background-color="#0079F1" 
          v-model="tabPlan" 
          style="border-radius: 25px"
          grow
          >
          <v-tab v-for="(item) in ['URL_SHORTNER', 'SMS']" 
            :key="item" 
            :tab-value="item" 
            :class="(item != tabPlan ? '': 'color-green-blue') + ` ma-1 text-lowercase`" 
            active-class="tab-item-subscrible-year">
            {{ $t(item) }}
          </v-tab>
        </v-tabs>
    </v-card> 
    <div class="mt-4">
      <v-row v-if="loading">
        <v-col v-for="i in 3" :key="`plan_${i}`">
          <v-skeleton-loader
            type="list-item-three-line, card-heading"
          />
        </v-col>
      </v-row>
      <v-card v-else elevation="0">
        <carousel :autoplay="false" :perPage="['xs'].includes($vuetify.breakpoint.name) ? 1 : ['sm'].includes($vuetify.breakpoint.name) ? 2.2 : 3.3" :minSwipeDistance="10">
          <slide v-for="(plan) in plansByPrice" :key="plan.id" >
            <v-card elevation="0" outlined width="95%">
              <v-card-title class="mb-0 pb-0">
                <div class="color-green-blue">
                  {{$t(`plan`)}}
                </div>
                <v-spacer/>
                <v-icon color="primary" v-if="plan.id > 1">mdi-crown-outline</v-icon>
              </v-card-title>
              <v-card-title class="primary--text mt-0 pt-0 ml-5">
                <b>{{$t(`plan_${plan.name}`)}}</b>
              </v-card-title>
              <v-card-title class="primary--text">
                <v-spacer/>
                <v-slide-y-transition>
                  <div v-if="discount && !subscribleYear && plan.id != 1">
                    <v-card-title class="pa-0 ma-0"><v-spacer/><small>de R${{ formatPrice(plan.price) }} por</small><v-spacer/></v-card-title>
                    <v-card-title class="pa-0"><v-spacer/>R$<big><b>{{ formatPrice(plan.price - (plan.id == 2 ? 2 : 5)).split(`,`)[0] }}</b> </big>,<small>{{formatPrice(plan.price - (plan.id == 2 ? 2 : 5)).split(`,`)[1]}}</small>/{{$t('month')}}<v-spacer/></v-card-title>
                  </div>
                  <div v-else>
                    <span v-if="subscribleYear">
                      R$<big ><b>{{ formatPrice(plan.annualPrice).split(`,`)[0] }}</b> </big>,<small>{{formatPrice(plan.annualPrice).split(`,`)[1]}}</small>/{{$t('year')}}
                    </span>
                    <span v-else>
                      R$<big><b>{{ formatPrice(plan.price).split(`,`)[0] }}</b> </big>,<small>{{formatPrice(plan.price).split(`,`)[1]}}</small>/{{$t('month')}}
                    </span>
                  </div>
                </v-slide-y-transition>
                <v-spacer/>
              </v-card-title>
              <v-card-text class="text-center">
                <a :href="login" v-if="!screenData.auth">
                  <v-card  small dark color="primary" class="card-corner-radius pa-3" >
                    {{$t(`register`)}}
                  </v-card>
                </a>
                <v-card v-else-if="plan.id == 1 && screenData && screenData.auth" small dark color="grey" class="card-corner-radius pa-3" disabled>
                  {{$t(`getPlan`)}}
                </v-card>
                <v-card v-else small dark :color="screenData.auth.user.userHasSubscriptionPlans.filter(v => v.subscriptionPlan.id == plan.id)[0] ? 'grey' : `primary`" @click="getPlan(plan)" class="card-corner-radius pa-3" :disabled="screenData.auth.user.userHasSubscriptionPlans.filter(v => v.subscriptionPlan.id == plan.id)[0]">
                  {{$t(`getPlan`)}}
                </v-card>
              </v-card-text>
              <v-list>
                <div v-if=" discount && !subscribleYear && plan.id == 3 && false">
                  <v-list-item>
                    <v-list-item-icon>
                      <v-icon color="primary">mdi-check-circle</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content class="primary--text">
                      <b>+R$8,00 de crédito para envio de SMS</b>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-icon>
                      <v-icon color="primary">mdi-check-circle</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content class="primary--text">
                      <b>+Divulgação da sua link para bio em nosso site (somente para os 100 primeiros assinantes)</b>
                    </v-list-item-content>
                  </v-list-item>
                </div>
                <v-list-item v-for="(planInclude) in plan.subscriptionPlanIncludes" :key="`include-${planInclude.id}`">
                  <v-list-item-icon>
                    <v-icon color="primary">mdi-check-circle</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    {{$t(`${planInclude.name}`)}}
                  </v-list-item-content>
                  <v-list-item-action>
                    <!-- activator prop (not v-slot:activator) on purpose: see
                         SiteHeader.vue for why - avoids Detachable relocating
                         this button and breaking hydration. Per-item id since
                         this is inside a v-for. -->
                    <v-btn
                      :id="`plan-${plan.id}-tooltip-activator-${planInclude.id}`"
                      color="grey lighten-1"
                      dark
                      icon
                    >
                      <v-icon>mdi-information-outline</v-icon>
                    </v-btn>
                    <v-tooltip :activator="`#plan-${plan.id}-tooltip-activator-${planInclude.id}`" bottom color="primary">
                      <v-card max-width="400" elevation="0" color="transparent" dark>
                        <v-icon class="mr-2">mdi-information-outline</v-icon>
                        <span v-html="$t(`desc_${planInclude.name}`).description"></span>
                      </v-card>
                    </v-tooltip>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
            </v-card>
          </slide>
        </carousel>
      </v-card>
    </div>
    <v-dialog v-model="dialogLogin" width="400" persistent>
      <v-card v-if="plan">  
        <v-card-title>{{$t(`assignPlan`).replace('{plan}', $t(`plan_${plan.name}`))}}</v-card-title>
        <v-card-text class="mt-0 pt-0 mb-0 pb-0">
          <v-alert type="info">
            {{$t(`assignPlanAuth`)}}  
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <BtnLogin :screenData="screenData"/>
          <v-spacer/>
          <v-btn color="red" text @click="dialogLogin = false">
            {{ $t('cancel') }}
          </v-btn>
          <v-spacer/>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogSubscrible" width="500" persistent :fullscreen="['xs'].includes($vuetify.breakpoint.name)">
      <v-card v-if="plan" class="checkout-card">
        <div class="checkout-header" v-if="!success">
          <span class="checkout-header-title">{{ $t('plan') }}</span>
          <div class="checkout-header-actions">
            <v-menu offset-y left>
              <template v-slot:activator="{ on, attrs }">
                <button type="button" class="checkout-lang-switch" v-bind="attrs" v-on="on" :aria-label="$t('home.languageSelector')">
                  <country-flag :country="currentLocale === 'pt-br' ? 'br' : 'us'" size="small" class="checkout-lang-flag"/>
                  <span>{{ currentLocale === 'pt-br' ? 'PT' : 'EN' }}</span>
                  <v-icon size="14" color="#5B6472">mdi-chevron-down</v-icon>
                </button>
              </template>
              <v-list dense class="checkout-lang-menu">
                <v-list-item @click="changeLocale('pt-br')" :class="{ 'checkout-lang-menu-item-active': currentLocale === 'pt-br' }">
                  <country-flag country="br" size="small" class="mr-2"/>
                  <v-list-item-title>Português</v-list-item-title>
                </v-list-item>
                <v-list-item @click="changeLocale('en')" :class="{ 'checkout-lang-menu-item-active': currentLocale === 'en' }">
                  <country-flag country="us" size="small" class="mr-2"/>
                  <v-list-item-title>English</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <button type="button" class="checkout-close-btn" @click="requestClose">
              <v-icon size="18" color="#7E8EA6">mdi-close</v-icon>
            </button>
          </div>
        </div>
        <div class="checkout-plan-summary" v-if="!success">
          <div class="checkout-plan-summary-name">{{ $t(`plan_${plan.name}`) }}</div>
          <div class="checkout-plan-summary-price">
            <div v-if="discount && !subscribleYear && plan.id != 1">
              R$<big><b>{{ formatPrice(plan.price - (plan.id == 2 ? 2 : 5)).split(`,`)[0] }}</b></big>,<small>{{formatPrice(plan.price - (plan.id == 2 ? 2 : 5)).split(`,`)[1]}}</small>/{{$t('month')}}
            </div>
            <div v-else>
              <span v-if="subscribleYear">
                R$<big><b>{{ formatPrice(plan.annualPrice).split(`,`)[0] }}</b></big>,<small>{{formatPrice(plan.annualPrice).split(`,`)[1]}}/{{$t('year')}}</small>
              </span>
              <span v-else>
                R$<big><b>{{ formatPrice(plan.price).split(`,`)[0] }}</b></big>,<small>{{formatPrice(plan.price).split(`,`)[1]}}/{{$t('month')}}</small>
              </span>
            </div>
          </div>
        </div>
        <div v-if="!success">
          <v-card-text>
            <div class="checkout-trial-banner">
              <v-icon size="18" color="#0277BD" class="mr-2">mdi-clock-outline</v-icon>
              <div>
                <div class="checkout-trial-banner-title">{{$t(`assignPlan`).replace('{plan}', $t(`plan_${plan.name}`))}}</div>
                <div class="checkout-trial-banner-text">{{$t('trialPeriod')}}</div>
              </div>
            </div>
          </v-card-text>
          <v-card-text >
            <v-form @submit.prevent="" v-model="subscriptionValid">
              <div class="checkout-section-label">
                <span>{{ $t('sectionDocument') }}</span>
              </div>
              <v-row>
                <v-col cols="12" xs="12" sm="12">
                  <v-text-field
                    required
                    clearable
                    :label="`${$t('cpfCnpj')}*`"
                    placeholder="000.000.000-00"
                    v-model="subscription.customer.document"
                    :disabled="loadSubscription"
                    prepend-inner-icon="mdi-card-account-details"
                    @keyup="subscription.customer.document = subscription.customer.document.replace(/[^0-9]+/g,'')"
                    maxlength="16"
                    counter
                    :hide-details="isCpf(subscription.customer.document) || isCnpj(subscription.customer.document)"
                    :rules="[
                      v => !!v || $t('documentRequired'),
                      v => (isCpf(v) || isCnpj(v)) || $t('documentInvalid'),
                    ]"
                    filled
                    rounded
                    dense
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xs="12" sm="12">
                  <v-text-field
                    required
                    clearable
                    :label="`${$t('name')}*`"
                    v-model="subscription.customer.name"
                    :disabled="loadSubscription"
                    prepend-inner-icon="mdi-clipboard-account"
                    maxlength="40"
                    counter
                    hide-details
                    :rules="[
                      v => !!v || $t('required'),
                    ]"
                    filled
                    rounded
                    dense
                  />
                </v-col>
              </v-row>
              <div class="checkout-section-label">
                <span>{{ $t('sectionContact') }}</span>
              </div>
              <v-row>
                <v-col cols="3" xs="3" sm="3">
                  <v-text-field
                    required
                    :label="`${$t('ddi')}*`"
                    placeholder="+55"
                    v-model="subscription.customer.phone.countryCode"
                    :disabled="loadSubscription"
                    @keyup="subscription.customer.phone.countryCode = subscription.customer.phone.countryCode.replace(/[^0-9]+/g,'')"
                    maxlength="5"
                    counter
                    :hide-details="subscription.customer.phone.countryCode"
                    :rules="[
                      v => !!v || $t('ddiRequired'),
                    ]"
                    filled
                    rounded
                    dense
                  />
              </v-col>
                <v-col cols="3" xs="3" sm="3">
                  <v-text-field
                    required
                    :label="`${$t('ddd')}*`"
                    placeholder="11"
                    filled
                    rounded
                    dense
                    v-model="subscription.customer.phone.areaCode"
                    :disabled="loadSubscription"
                    @keyup="subscription.customer.phone.areaCode = subscription.customer.phone.areaCode.replace(/[^0-9]+/g,'')"
                    maxlength="5"
                    counter
                    :hide-details="subscription.customer.phone.areaCode"
                    :rules="[
                      v => !!v || $t('dddRequired'),
                    ]"
                  />
                </v-col>
                <v-col cols="6" xs="6" sm="6">
                  <v-text-field
                    required
                    clearable
                    :label="`${$t('number')}*`"
                    placeholder="999999999"
                    filled
                    rounded
                    dense
                    v-model="subscription.customer.phone.number"
                    :disabled="loadSubscription"
                    @keyup="subscription.customer.phone.number = subscription.customer.phone.number.replace(/[^0-9]+/g,'')"
                    maxlength="15"
                    counter
                    :hide-details="subscription.customer.phone.number >= 11"
                    :rules="[
                      v => !!v || $t('phoneNumberRequired'),
                      subscription.customer.phone.number >= 13 || $t('phoneNumberInvalid'),
                    ]"
                  />
                </v-col>
              </v-row>
              <div class="checkout-section-label">
                <span>{{ $t('sectionCardData') }}</span>
              </div>
              <div class="credit-card-visual">
                <div class="credit-card-face-wrap" :class="{ 'is-flipped': cardFocusCvv }">
                  <div class="credit-card-face credit-card-front">
                    <div class="credit-card-top">
                      <div class="credit-card-chip"></div>
                      <div class="credit-card-brand">{{ cardBrandLabel }}</div>
                    </div>
                    <div class="credit-card-number">{{ cardNumberMasked }}</div>
                    <div class="credit-card-bottom">
                      <div class="credit-card-holder">
                        <span class="credit-card-label">{{ $t('creditCardNamePrinted') }}</span>
                        <span>{{ subscription.card.holderName || '—' }}</span>
                      </div>
                      <div class="credit-card-expiry">
                        <span class="credit-card-label">{{ $t('cardExpiration') }}</span>
                        <span>{{ subscription.card.expiration || '••/••' }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="credit-card-face credit-card-back">
                    <div class="credit-card-stripe"></div>
                    <div class="credit-card-cvv-box">
                      <span class="credit-card-label">CVV</span>
                      <span>{{ subscription.card.cvv || '•••' }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <v-row>
                <v-col cols="7" xs="7" sm="7" md="7">
                  <v-text-field
                    required
                    clearable
                    :label="`${$t('cardNumber')}*`"
                    placeholder="0000 0000 0000 0000"
                    filled
                    rounded
                    dense
                    v-model="subscription.card.number"
                    :disabled="loadSubscription"
                    prepend-inner-icon="mdi-credit-card"
                    @keyup="subscription.card.number = subscription.card.number.replace(/[^0-9]+/g,'')"
                    maxlength="19"
                    counter
                    :hide-details="cardValidadion.card_number"
                    @blur="verifyCard"
                    :rules="[
                      v => !!v || $t('cardNumberRequired'),
                      cardValidadion.card_number || $t('cardNumberInvalid'),
                    ]"
                  />
                </v-col>
                <v-col cols="5" xs="5" sm="5" md="5">
                  <v-text-field
                    required
                    clearable
                    :label="`${$t('cvv')}*`"
                    placeholder="999"
                    filled
                    rounded
                    dense
                    v-model.trim="subscription.card.cvv"
                    :disabled="loadSubscription"
                    prepend-inner-icon="mdi-security"
                    maxlength="3"
                    @keyup="subscription.card.cvv = subscription.card.cvv.replace(/[^0-9]+/g,'')"
                    @focus="cardFocusCvv = true"
                    @blur="cardFocusCvv = false, verifyCard()"
                    counter
                    :hide-details="cardValidadion.card_cvv"
                    :rules="[
                      v => !!v || $t('cvvRequired'),
                      cardValidadion.card_cvv || $t('cvvInvalid'),
                    ]"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col ols="12" xs="12" sm="7" md="7">
                  <v-text-field
                    required
                    :label="`${$t('creditCardNamePrinted')}*`"
                    placeholder="Augusto E Santos"
                    filled
                    rounded
                    dense
                    v-model.trim="subscription.card.holderName"
                    :disabled="loadSubscription"
                    prepend-inner-icon="mdi-account"
                    maxlength="40"
                    clearable
                    :hide-details="cardValidadion.card_holder_name"
                    @keyup="subscription.card.holderName = subscription.card.holderName.toUpperCase()"
                    @blur="verifyCard"
                    :rules="[
                      v => !!v || $t('cardNameRequired'),
                      cardValidadion.card_holder_name || $t('cardNameInvalid'),
                    ]"
                  />
                </v-col>
                <v-col cols="12" xs="12" sm="5" md="5">
                  <v-text-field
                    required
                    :label="`${$t('cardExpiration')}*`"
                    placeholder="12/99"
                    filled
                    rounded
                    dense
                    v-model="subscription.card.expiration"
                    :disabled="loadSubscription"
                    prepend-inner-icon="mdi-calendar"
                    mask="##/##"
                    clearable
                    @keyup="subscription.card.expiration = subscription.card.expiration.replace(/[^0-9//]+/g,''); subscription.card.expiration.length == 2 && !subscription.card.expiration.includes('/') ? subscription.card.expiration = `${subscription.card.expiration}/` : ''"
                    maxlength="5"
                    counter
                    @blur="verifyCard()"
                    :hide-details="cardValidadion.card_expiration_date"
                    :rules="[
                      v => !!v || $t('cardExpirationRequired'),
                      cardValidadion.card_expiration_date || $t('cardExpirationInvalid'),
                    ]"
                  />
                </v-col>
              </v-row>
              <v-card-actions class="mr-0 pr-0">
                <v-spacer/>
                <v-fade-transition leave-absolute hide-on-leave>
                  <v-chip v-if="loadVerifyCard" color="green" dark>
                    <span class="mr-2">{{ $t('verifyingCardData') }}</span>
                    <v-progress-circular  indeterminate width="1" color="white" size="20"/>
                  </v-chip>
                  <v-chip dark v-else-if="isCardValid() && card_hash" color="green" small :loading="loadSubscription" :disabled="!subscriptionValid">
                    <v-icon small color="white">mdi-check</v-icon>
                  </v-chip>
                  <v-chip dark v-else color="red">
                    <span class="mr-2">{{ $t('invalidCard') }}</span>
                    <v-icon small color="white">mdi-alert-circle-outline</v-icon>
                  </v-chip>
                </v-fade-transition>
              </v-card-actions>
              <div class="checkout-section-label">
                <span>{{ $t('sectionBillingAddress') }}</span>
              </div>
              <v-row>
                <v-col cols="12" xs="12" sm="12">
                  <v-text-field
                    :label="`${$t('publicStreet')}*`"
                    placeholder="Rua ou Av. .... "
                    filled
                    rounded
                    dense
                    required
                    clearable
                    v-model="subscription.card.billingAddress.line1"
                    :disabled="loadSubscription"
                    maxlength="55"
                    :hide-details="!!subscription.card.billingAddress.line1"
                    :rules="[
                      v => !!v || $t('streetRequired'),
                    ]"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field
                    :label="`${$t('complement')}`"
                    placeholder="AP. 303"
                    filled
                    rounded
                    dense
                    clearable
                    v-model.trim="subscription.card.billingAddress.line2"
                    :disabled="loadSubscription"
                    hide-details
                    maxlength="30"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xs="12" sm="12">
                  <v-text-field
                    required
                    :label="`${$t('cep')}*`"
                    placeholder="99999-999"
                    filled
                    rounded
                    v-model.trim="subscription.card.billingAddress.zipCode"
                    :disabled="loadSubscription"
                    clearable
                    maxlength="9"
                    mask="#####-###"
                    @keyup="subscription.card.billingAddress.zipCode = subscription.card.billingAddress.zipCode.replace(/[^0-9-]+/g,''); subscription.card.billingAddress.zipCode.length == 5 && !subscription.card.billingAddress.zipCode.includes('-') ? subscription.card.billingAddress.zipCode = `${subscription.card.billingAddress.zipCode}-` : ''"
                    counter
                    :hide-details="subscription.card.billingAddress.zipCode.length >= 9"
                    :rules="[
                      v => !!v || $t('cepRequired'),
                      v => v.length >= 9 || $t('cepInvalid'),
                    ]"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xs="12" sm="8">
                  <v-text-field
                    :label="`${$t('city')}*`"
                    placeholder="Salvador"
                    filled
                    rounded
                    required
                    v-model="subscription.card.billingAddress.city"
                    :disabled="loadSubscription"
                    maxlength="50"
                    clearable
                    :hide-details="!!subscription.card.billingAddress.city"
                    :rules="[
                      v => !!v || $t('cityRequired'),
                    ]"
                  />
                </v-col>
                <v-col>
                  <v-select
                    :items="['AC','AL','AP','AM','BA','CE','DF','ES','GO','MA','MT','MS','MG','PA','PB','PR','PE','PI','RJ','RN','RS','RO','RR','SC','SP','SE','TO']"
                    :label="`${$t('state')}*`"
                    filled
                    rounded
                    required
                    v-model="subscription.card.billingAddress.state"
                    :disabled="loadSubscription"
                    maxlength="50"
                    :hide-details="!!subscription.card.billingAddress.state"
                    :rules="[
                      v => !!v || $t('stateRequired'),
                    ]"
                  />
                </v-col>
              </v-row>

              <v-card-actions class="pr-0 pl-0">
                <v-alert type="error" dense v-if="error">
                  {{ $t('subscriptionError') }}
                </v-alert>
              </v-card-actions>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <button type="button" class="checkout-submit-btn" @click="subscrible" :disabled="!subscriptionValid || loadSubscription">
              <v-progress-circular v-if="loadSubscription" indeterminate size="18" width="2" color="#FFFFFF" class="mr-2"/>
              {{ $t('subscribeButton') }}
            </button>
          </v-card-actions>
          <v-card-text v-if="discount && !subscribleYear && plan.id != 1">
            <v-alert dense small color="#78FFFF">
              <v-card-actions style="color: #0C9B93;">
                <v-icon color="#0C9B93" small class="mr-2">mdi-information-slab-circle-outline</v-icon>
                <small>{{ $t('discountNotice', { discountedPrice: formatPrice(plan.price - (plan.id == 2 ? 2 : 5)), fullPrice: formatPrice(plan.price) }) }}</small>
              </v-card-actions>
            </v-alert>
          </v-card-text>
        </div>
        <v-fade-transition>
          <div v-if="success" class="checkout-success">
            <div class="checkout-success-icon">
              <v-icon size="34" color="#FFFFFF">mdi-check-bold</v-icon>
            </div>
            <h3 class="checkout-success-title">{{ $t('assignPlanSuccessTitle').replace('{plan}', $t(`plan_${plan.name}`)) }}</h3>
            <p class="checkout-success-text">{{ $t('assignPlanSuccess') }}</p>
            <div class="checkout-success-trial" v-if="plan.id != 1">
              <v-icon size="14" color="#0277BD" class="mr-1">mdi-clock-outline</v-icon>
              {{ $t('trialPeriod') }}
            </div>
            <button type="button" class="checkout-submit-btn" @click="reload">
              {{ $t('toAccessPanel') }}
              <v-icon size="16" color="#FFFFFF" class="ml-1">mdi-arrow-right</v-icon>
            </button>
          </div>
        </v-fade-transition>
      </v-card>
    </v-dialog>

    <v-dialog v-model="confirmCloseDialog" width="380" persistent>
      <v-card class="checkout-confirm-card">
        <v-icon size="34" color="#E5484D">mdi-alert-circle-outline</v-icon>
        <h3 class="checkout-confirm-title">{{ $t('closeCheckoutConfirmTitle') }}</h3>
        <p class="checkout-confirm-text">{{ $t('closeCheckoutConfirmText') }}</p>
        <div class="checkout-confirm-actions">
          <button type="button" class="checkout-confirm-btn-stay" @click="confirmCloseDialog = false">
            {{ $t('closeCheckoutConfirmStay') }}
          </button>
          <button type="button" class="checkout-confirm-btn-leave" @click="closeDialog">
            {{ $t('closeCheckoutConfirmLeave') }}
          </button>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogAlreadyPlan" width="400">
      <v-card v-if="user">
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" icon @click="dialogAlreadyPlan = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-actions>
        <v-card-text>
          <v-alert type="info">
            {{$t(`youAssignPlan`)}} {{$t(`plan_`)}} --
          </v-alert>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import BtnLogin from "./BtnLogin.vue"
import {apiV1SubscriptionPlan} from "../../../service/resources/api-v1-subscription-plan"
import {apiV1SubscriptionPlanInclude} from "../../../service/resources/api-v1-subscription-plan-include"
import {apiV1Subscription} from "../../../service/resources/api-v1-subscription"
import pagarme from 'pagarme'
import { apiV1Auth } from "../../../service/resources/api-v1-auth"
import authSession from "../../../service/auth-session"
import localeService from "../../../service/locale"
  export default {
    name: 'SubscrioptionAndPlans',
    components: {
    BtnLogin
},
    props: ['screenData', 'planId'],
    data: () => ({
      discount: false,
      subscription: {customer: {phone: {countryCode: '', number: '', areaCode: ''}, document: '', name: ''}, card: {number: '', cvv: '', expiration: '', holderName: '', billingAddress: {line1: '', line2:'', zipCode:'', city: '', state: ''}}},
      loadSubscription: false,
      subscriptionValid: false,
      error: null,
      success: false,
      loadVerifyCard: false,
      cardValidadion: {
        brand: null,
        card_cvv: false,
        card_expiration_date: false,
        card_holder_name: false,
        card_number: false,
      },
      card_hash: null,      
      
      loading: false,
      plan: null,
      loadingPlanIncludes: false,
      planIncludes: {content: []},
      plans: {content: []},
      dialogLogin: false,
      subscribleYear: false,
      dialogSubscrible: false,
      user: null,
      dialogAlreadyPlan: false,
      tabPlan: 'URL_SHORTNER',
      cardFocusCvv: false,
      confirmCloseDialog: false,
    }),
    mounted: function() {
      if(this.$route.query.d) {
        localStorage.setItem('discount', this.$route.query.d)
      }
      this.discount = localStorage.getItem("discount")
      //this.discount = true
      if(process.env.VUE_APP_ENVIROMENT == 'DEV') {
        this.subscription.customer.document = process.env.VUE_APP_DOCUMENT
        this.subscription.customer.name = process.env.VUE_APP_NAME
        this.subscription.customer.phone.countryCode = process.env.VUE_APP_DDI
        this.subscription.customer.phone.areaCode = process.env.VUE_APP_DDD
        this.subscription.customer.phone.number = process.env.VUE_APP_TEL

        this.subscription.card.holderName = process.env.VUE_APP_CARD_HOLDER_NAME
        this.subscription.card.number = process.env.VUE_APP_CARD_NUMBER
        this.subscription.card.expiration = process.env.VUE_APP_CARD_EXPIRATION
        this.subscription.card.cvv = process.env.VUE_APP_CARD_CVV
        this.subscription.card.billingAddress.line1 = process.env.VUE_APP_ADDRESS
        this.subscription.card.billingAddress.line2 = process.env.VUE_APP_COMPLEMENT
        this.subscription.card.billingAddress.zipCode = process.env.VUE_APP_CEP
        this.subscription.card.billingAddress.city = process.env.VUE_APP_CITY
        this.subscription.card.billingAddress.state = process.env.VUE_APP_UF
        this.verifyCard()
      }
      this.loading = true
      apiV1SubscriptionPlan.page({
        page: 0,
        size: 100,
        active: true,
        embedSubscriptionPlanInclude: true,
      }).then(result => {
        this.plans = result.data
        this.loading = false
        if(this.planId) {
          this.getPlan(this.plans.content.filter(p => p.id == this.planId)[0])
        }
      })
      this.loadingPlanIncludes = true
      apiV1SubscriptionPlanInclude.page({
        page: 0,
        size: 100,
        active: true,
        orderBy: 'order' 
      }).then(result => {
        result.data.content.forEach(element => {
          element.open = false
        });
        this.planIncludes = result.data
        this.loadingPlanIncludes = false
      })
    },
    watch: {
      'dialogLogin' : function(isOpen) {
        if(!isOpen) {
          localStorage.removeItem('planSelectAuth')
        }
      },
      'dialogSubscrible' : function(isOpen) {
        if(!isOpen) {
          localStorage.removeItem('planSelectAuth')
        }
      }
    },
    computed: {
      login: function() {
        return `${process.env.VUE_APP_API_V1_URL}/oauth2/authorization/google`
      },
      plansByPrice: function() {
        return this.plans.content.slice().sort((a, b) => a.price - b.price)
      },
      currentLocale: function() {
        return this.$i18n.locale
      },
      hasUnsavedData: function() {
        const c = this.subscription.customer
        const cd = this.subscription.card
        return !!(c.document || c.name || c.phone.number || cd.number || cd.holderName || cd.cvv || cd.expiration || cd.billingAddress.line1 || cd.billingAddress.city)
      },
      cardNumberMasked: function() {
        const digits = (this.subscription.card.number || '').padEnd(16, '•')
        const groups = []
        for (let i = 0; i < 16; i += 4)
          groups.push(digits.slice(i, i + 4))
        return groups.join(' ')
      },
      cardBrandLabel: function() {
        const n = this.subscription.card.number || ''
        if (/^4/.test(n)) return 'VISA'
        if (/^(5[1-5]|2[2-7])/.test(n)) return 'MASTERCARD'
        if (/^3[47]/.test(n)) return 'AMEX'
        if (/^(6011|65)/.test(n)) return 'DISCOVER'
        if (/^(4011|4312|4389|4514|4573|6277|6362|5041|5066|5090|6363)/.test(n)) return 'ELO'
        if (/^606282/.test(n)) return 'HIPERCARD'
        if (/^3(0[0-5]|[68])/.test(n)) return 'DINERS'
        return ''
      },
    },
    methods: {
      reload: function() {
        location.reload()
      },
      changeLocale: function(locale) {
        localeService.setLocale(locale)
      },
      requestClose: function() {
        if (this.hasUnsavedData) {
          this.confirmCloseDialog = true
        } else {
          this.closeDialog()
        }
      },
      closeDialog: function() {
        this.confirmCloseDialog = false
        this.dialogSubscrible = false
        this.dialogPlansAndPrices = false
      },
      isCardValid: function() {
        let status = this.cardValidadion.card_number 
          && this.cardValidadion.card_holder_name 
          && this.cardValidadion.card_expiration_date 
          && this.cardValidadion.card_cvv
          && this.cardValidadion.brand
        return status
      },
      isCpf: function(strCPF) {
        var Soma
        var Resto
        Soma = 0
        if (!strCPF || strCPF == "00000000000" || strCPF.length != 11) return false
        var i = 1
        for (i=1; i<=9; i++) Soma = Soma + parseInt(strCPF.substring(i-1, i)) * (11 - i)
          Resto = (Soma * 10) % 11
        if ((Resto == 10) || (Resto == 11))  Resto = 0
        if (Resto != parseInt(strCPF.substring(9, 10)) ) return false
        Soma = 0;
        for (i = 1; i <= 10; i++) Soma = Soma + parseInt(strCPF.substring(i-1, i)) * (12 - i)
        Resto = (Soma * 10) % 11
        if ((Resto == 10) || (Resto == 11))  Resto = 0
        if (Resto != parseInt(strCPF.substring(10, 11) ) ) return false
        return true
      },
      isCnpj: function(cnpj) {
        cnpj = !cnpj ? cnpj.replace(/[^\d]+/g,'') : cnpj;
    
        if(!cnpj || cnpj == '' || cnpj.length != 14) return false;
    
        // Elimina CNPJs invalidos conhecidos
        if (cnpj == "00000000000000" || 
            cnpj == "11111111111111" || 
            cnpj == "22222222222222" || 
            cnpj == "33333333333333" || 
            cnpj == "44444444444444" || 
            cnpj == "55555555555555" || 
            cnpj == "66666666666666" || 
            cnpj == "77777777777777" || 
            cnpj == "88888888888888" || 
            cnpj == "99999999999999")
            return false;
            
        // Valida DVs
        var tamanho = cnpj.length - 2
        var numeros = cnpj.substring(0,tamanho);
        var digitos = cnpj.substring(tamanho);
        var soma = 0;
        var pos = tamanho - 7;
        var i = 0
        for (i = tamanho; i >= 1; i--) {
          soma += numeros.charAt(tamanho - i) * pos--;
          if (pos < 2)
                pos = 9;
        }
        var resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
        if (resultado != digitos.charAt(0))
            return false;
            
        tamanho = tamanho + 1;
        numeros = cnpj.substring(0,tamanho);
        soma = 0;
        pos = tamanho - 7;
        for (i = tamanho; i >= 1; i--) {
          soma += numeros.charAt(tamanho - i) * pos--;
          if (pos < 2)
                pos = 9;
        }
        resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
        if (resultado != digitos.charAt(1))
              return false;
              
        return true;
      },
      verifyCard: function() {
        this.loadVerifyCard = true
        const card = {
          card_number: this.subscription.card.number,
          card_holder_name: this.subscription.card.holderName,
          card_expiration_date: this.subscription.card.expiration.replace('/', ''),
          card_cvv: this.subscription.card.cvv,
        }
        this.cardValidadion = pagarme.validate({card: card}).card
        setTimeout(() => {
          this.loadVerifyCard = false
        }, 1000);
        if(this.isCardValid()) {
          pagarme.client.connect({ encryption_key: process.env.VUE_APP_PAGARME_APP_ID })
          .then(client => client.security.encrypt(card))
          .then(card_hash => {
            this.card_hash = card_hash
            console.log(card_hash)
            this.loadVerifyCard = false
          })
        }
      },
      formatPrice(value) {
        let val = (value/1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      },
      getPlan: function(plan){
        this.plan = plan
        if(!authSession.state.authenticated) {
          this.dialogLogin = true
          localStorage.setItem('planSelectAuth' , plan.id)
        }else {
          apiV1Auth.get().then(result => {
            this.user = result.data.user
            if(result.data.user.userHasSubscriptionPlans.filter(v => v.subscriptionPlan.id == plan.id)[0]) {
              this.dialogAlreadyPlan = true
            }else {
              this.dialogSubscrible = true
            }
          })
        }
      },
      subscrible: function() {
        this.error = null
        this.loadSubscription = true

        this.subscription.subscriptionPlan = this.plan
        this.subscription.early = this.subscribleYear
        this.subscription.discount = this.discount ? true : false
        apiV1Subscription.subscrible(this.subscription).then(() => {
          apiV1Auth.get().then(response => {
            this.loadSubscription = false
            this.success = true
            this.screenData.auth = response.data
          })
        }).catch(err => {
          this.error = err
          this.loadSubscription = false
        })
      },
    },
  }
</script>
<style scoped>
/* Large desktops and laptops */
@media (min-width: 1200px) {

}

/* Landscape tablets and medium desktops */
@media (min-width: 992px) and (max-width: 1199px) {

}

/* Portrait tablets and small desktops */
@media (min-width: 768px) and (max-width: 991px) {

}

/* Landscape phones and portrait tablets */
@media (max-width: 767px) {

}

/* Portrait phones and smaller */
@media (max-width: 480px) {
  .plan-name-display {
    writing-mode: vertical-rl !important;
  }

}

.header-title {
  color: #1A237E;
  margin-bottom: 0.66667rem;
}

.text-description-1 {
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.7;
  margin: 0;
  text-align: left;
  color: #718096;
}
.tab-item-subscrible-year{
  color: #0079F1;
  background-color: #78FFFF;
  border-radius: 25px;
}

.tabs-subscrible-year {
  padding: 2px !important;
}

.color-green-blue{
  color: #00E6DB !important
}

.checkout-card {
  font-family: 'Montserrat', sans-serif;
  border-radius: 1.5rem !important;
  overflow: hidden;
}
.checkout-header {
  display: flex;
  align-items: center;
  padding: 1.5rem 1.75rem 0;
}
.checkout-header-title {
  font-weight: 900;
  font-size: 1.15rem;
  color: #101827;
}
.checkout-header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
}
.checkout-close-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: none;
  background: #F7F5EF;
  cursor: pointer;
  transition: background 0.2s ease;
}
.checkout-close-btn:hover {
  background: #E3F1FA;
}
.checkout-lang-switch {
  display: flex;
  align-items: center;
  gap: 6px;
  background: #F7F5EF;
  border: 1px solid rgba(16,24,39,0.1);
  border-radius: 999px;
  padding: 0.35rem 0.65rem;
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  font-size: 0.74rem;
  color: #101827;
  cursor: pointer;
  transition: border-color 0.2s ease;
}
.checkout-lang-switch:hover {
  border-color: #0277BD;
}
.checkout-lang-flag ::v-deep svg {
  width: 16px !important;
  height: 16px !important;
  border-radius: 50%;
}
.checkout-lang-menu {
  font-family: 'Montserrat', sans-serif;
}
.checkout-lang-menu-item-active ::v-deep .v-list-item__title {
  color: #0277BD;
  font-weight: 700;
}
.checkout-plan-summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 1.25rem 1.75rem 0;
  padding: 1rem 1.25rem;
  border-radius: 1.1rem;
  background: linear-gradient(90deg, #00BDB3 0%, #0277BD 100%);
  color: #FFFFFF;
}
.checkout-plan-summary-name {
  font-weight: 800;
  font-size: 1rem;
  text-transform: lowercase;
}
.checkout-plan-summary-price {
  font-weight: 700;
  font-size: 0.95rem;
}
.checkout-trial-banner {
  display: flex;
  align-items: flex-start;
  background: #E3F1FA;
  border-radius: 1rem;
  padding: 0.9rem 1.1rem;
}
.checkout-trial-banner-title {
  font-weight: 700;
  font-size: 0.9rem;
  color: #101827;
}
.checkout-trial-banner-text {
  color: #5B6472;
  font-size: 0.82rem;
  margin-top: 0.2rem;
}
.checkout-section-label {
  margin: 1.5rem 0 0.75rem;
  padding-bottom: 0.4rem;
  border-bottom: 1px solid rgba(16,24,39,0.08);
}
.checkout-section-label span {
  color: #0277BD;
  font-weight: 700;
  font-size: 0.78rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.checkout-submit-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 0.85rem 1.5rem;
  border: none;
  border-radius: 999px;
  background: linear-gradient(90deg, #00BDB3 0%, #0277BD 100%);
  color: #FFFFFF;
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  font-size: 0.95rem;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease, opacity 0.2s ease;
  box-shadow: 0 8px 18px rgba(2, 119, 189, 0.28);
}
.checkout-submit-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 12px 24px rgba(2, 119, 189, 0.38);
}
.checkout-submit-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
  box-shadow: none;
}

/* Cartão de crédito visual — acompanha o preenchimento em tempo real e vira
 * (flip 3D) pra mostrar o CVV quando esse campo está focado. */
.credit-card-visual {
  perspective: 1200px;
  width: 100%;
  max-width: 320px;
  height: 180px;
  margin: 0.5rem auto 1.5rem;
}
.credit-card-face-wrap {
  position: relative;
  width: 100%;
  height: 100%;
  transition: transform 0.6s cubic-bezier(0.16,1,0.3,1);
  transform-style: preserve-3d;
}
.credit-card-face-wrap.is-flipped {
  transform: rotateY(180deg);
}
.credit-card-face {
  position: absolute;
  inset: 0;
  border-radius: 1.1rem;
  backface-visibility: hidden;
  padding: 1.35rem;
  color: #FFFFFF;
  box-shadow: 0 16px 32px rgba(16,24,39,0.18);
}
.credit-card-front {
  background: linear-gradient(135deg, #0277BD 0%, #00BDB3 100%);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.credit-card-back {
  background: linear-gradient(135deg, #101827 0%, #0277BD 100%);
  transform: rotateY(180deg);
}
.credit-card-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.credit-card-chip {
  width: 36px;
  height: 26px;
  border-radius: 6px;
  background: linear-gradient(135deg, #FFE9A8 0%, #D9B968 100%);
}
.credit-card-brand {
  font-weight: 800;
  font-size: 0.8rem;
  letter-spacing: 0.04em;
  min-height: 1em;
}
.credit-card-number {
  font-family: 'Courier New', monospace;
  font-size: 1.25rem;
  letter-spacing: 0.1em;
}
.credit-card-bottom {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 0.5rem;
}
.credit-card-label {
  display: block;
  font-size: 0.58rem;
  text-transform: uppercase;
  opacity: 0.7;
  letter-spacing: 0.05em;
  margin-bottom: 2px;
}
.credit-card-holder,
.credit-card-expiry {
  min-width: 0;
}
.credit-card-holder span:last-child {
  display: block;
  font-weight: 700;
  font-size: 0.8rem;
  text-transform: uppercase;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.credit-card-expiry span:last-child {
  font-weight: 700;
  font-size: 0.8rem;
}
.credit-card-stripe {
  height: 38px;
  background: #0A0A0A;
  margin: 1rem -1.35rem 0;
}
.credit-card-cvv-box {
  margin-top: 1.5rem;
  margin-left: auto;
  max-width: 78px;
  background: #FFFFFF;
  color: #101827;
  border-radius: 6px;
  padding: 0.45rem 0.7rem;
  text-align: right;
  font-family: 'Courier New', monospace;
  font-weight: 700;
}
@media (prefers-reduced-motion: reduce) {
  .credit-card-face-wrap {
    transition: none;
  }
}

.checkout-confirm-card {
  font-family: 'Montserrat', sans-serif;
  border-radius: 1.25rem !important;
  padding: 2rem 1.75rem;
  text-align: center;
}
.checkout-confirm-title {
  font-weight: 800;
  font-size: 1.05rem;
  color: #101827;
  margin: 0.75rem 0 0.5rem;
}
.checkout-confirm-text {
  color: #5B6472;
  font-size: 0.88rem;
  margin: 0 0 1.5rem;
}
.checkout-confirm-actions {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
}
.checkout-confirm-btn-stay {
  padding: 0.7rem 1.2rem;
  border: none;
  border-radius: 999px;
  background: linear-gradient(90deg, #00BDB3 0%, #0277BD 100%);
  color: #FFFFFF;
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  font-size: 0.88rem;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  box-shadow: 0 8px 18px rgba(2, 119, 189, 0.28);
}
.checkout-confirm-btn-stay:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 24px rgba(2, 119, 189, 0.38);
}
.checkout-confirm-btn-leave {
  padding: 0.7rem 1.2rem;
  border: none;
  border-radius: 999px;
  background: transparent;
  color: #E5484D;
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  font-size: 0.88rem;
  cursor: pointer;
}
.checkout-confirm-btn-leave:hover {
  background: rgba(229,72,77,0.08);
}

.checkout-success {
  padding: 2.75rem 1.75rem 2.25rem;
  text-align: center;
  font-family: 'Montserrat', sans-serif;
}
.checkout-success-icon {
  position: relative;
  width: 72px;
  height: 72px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1.25rem;
  background: linear-gradient(135deg, #00BDB3 0%, #0277BD 100%);
  box-shadow: 0 12px 24px rgba(2, 119, 189, 0.3);
  animation: checkout-success-pop 0.5s cubic-bezier(0.34,1.56,0.64,1);
}
.checkout-success-icon::after {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: 50%;
  animation: checkout-success-ring 1.6s ease-out 0.35s;
}
@keyframes checkout-success-pop {
  0% { transform: scale(0.4); opacity: 0; }
  60% { transform: scale(1.12); opacity: 1; }
  100% { transform: scale(1); opacity: 1; }
}
@keyframes checkout-success-ring {
  0% { box-shadow: 0 0 0 0 rgba(2, 119, 189, 0.4); }
  100% { box-shadow: 0 0 0 22px rgba(2, 119, 189, 0); }
}
.checkout-success-title {
  font-weight: 900;
  font-size: 1.2rem;
  color: #101827;
  margin: 0 0 0.6rem;
}
.checkout-success-text {
  color: #5B6472;
  font-size: 0.9rem;
  line-height: 1.6;
  max-width: 380px;
  margin: 0 auto 1.25rem;
}
.checkout-success-trial {
  display: inline-flex;
  align-items: center;
  background: #E3F1FA;
  color: #0277BD;
  font-weight: 700;
  font-size: 0.76rem;
  padding: 0.4rem 0.9rem;
  border-radius: 999px;
  margin-bottom: 1.75rem;
}
@media (prefers-reduced-motion: reduce) {
  .checkout-success-icon,
  .checkout-success-icon::after {
    animation: none;
  }
}
</style>